// extracted by mini-css-extract-plugin
export default {"error":"Error_error__vjC4+","error_div":"Error_error_div__E-W-D"};